const UserIcon = () => {
  return (
    <svg
      width="43"
      height="48"
      viewBox="0 0 43 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="usericon"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.2891 20C28.8119 20 33.2891 15.5229 33.2891 10C33.2891 4.47705 28.8119 0 23.2891 0C17.7662 0 13.2891 4.47705 13.2891 10C13.2891 15.5229 17.7662 20 23.2891 20ZM23.2891 16C26.6028 16 29.2891 13.3135 29.2891 10C29.2891 6.68652 26.6028 4 23.2891 4C19.9754 4 17.2891 6.68652 17.2891 10C17.2891 13.3135 19.9754 16 23.2891 16Z"
        fill="#FFB800"
      />
      <path
        d="M43 38.0831C41.9111 33.7724 39.0969 28.9665 35.5914 26.2316C32.0859 23.4967 27.769 22.0079 23.3229 22.0004C18.8768 21.9928 14.5549 23.4671 11.0401 26.1901C7.52541 28.9131 4.10345 33.693 3 38L7.79452 38.0307C8.677 34.5861 10.6821 31.5339 13.493 29.3561C16.3039 27.1784 19.7603 25.9994 23.3161 26.0054C26.8719 26.0114 30.3243 27.2021 33.1278 29.3893C35.9314 31.5765 37.9261 34.6356 38.797 38.0831L43 38.0831Z"
        fill="#FFB800"
      />
    </svg>
  );
};
export default UserIcon;
